module.exports = __webpack_public_path__ + "img/ban_06.a86ec078.png";